import React from 'react';
import { Button } from '@insurancemenu/imenu-components-lib';
import { Download } from '@insurancemenu/imenu-components-lib/dist/icons';
import StepHeader from 'components/common/headers/StepHeader';
import { observer } from 'mobx-react-lite';
import { CensusStepSectionStyled } from '../CensusStepSectionStyled';
import { StepSubtitleStyled } from '../StepSubtitleStyled';
import { DOWNLOAD_TEMPLATE_BTN_TEST_ID } from '../constants';

interface Props {
  downloadCensusTemplate: () => Promise<void>;
}

const CensusTemplateSection: React.FC<Props> = observer(({ downloadCensusTemplate }) => {
  return (
    <CensusStepSectionStyled>
      <StepHeader
        stepNumber="0"
        stepTitle="Add Employees"
        stepSubtitle={
          <StepSubtitleStyled>
            Load eligible employees using the downloadable Census template below. Once it’s complete, you can upload it
            directly on this page.
          </StepSubtitleStyled>
        }
      />
      <Button
        onClick={downloadCensusTemplate}
        leftIconProp={<Download />}
        size="large"
        color="primary"
        data-test-id={DOWNLOAD_TEMPLATE_BTN_TEST_ID}
      >
        Download Template
      </Button>
    </CensusStepSectionStyled>
  );
});

export default CensusTemplateSection;
